import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { store } from './store';
import { App } from './App';

const root = createRoot(document.getElementById('app-root'));
root.render(<App store={store} />);

if (module.hot) {
  module.hot.addStatusHandler(status => {
    if (status === 'prepare')
      console.log(`>>> HMR - ${new Date().toLocaleTimeString()} <<<`);
  });
}
